export class PasswordChange {
    public readonly password: string;
    public readonly oldPassword: string;

    constructor(password: string, oldPassword: string) {
        this.password = password;
        this.oldPassword = oldPassword;
    }
}
